import styled from 'styled-components';
import { FormItem } from '@xbcb/form-item-components';

export const StyledFormItem = styled(FormItem)`
  .ant-form-item {
    margin: 0;
  }
`;
